__turbopack_context__.v({
  "className": "XvZF2a_className",
  "variable": "XvZF2a_variable",
});
